import { Button, FilledInput, Modal, createStyles, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useInitText } from "../../../components/function/useInitText";
import { AppState } from "../../../root/RootReducer";
import { isEmpty } from "../../../utils/ObjectUtils";
import { CreateTimeline } from "../../store/actions/TimelineActions";
import styles from "./AddTimeline.module.css";
import { useHistory } from "react-router-dom";
import PuiTypography from "../../../components/elements/PuiTypography";
import { useInitFlag } from "../../../components/function/useInitFlag";
import PuiMessage from "../../../components/widgets/PuiMessage";

const useStyles = makeStyles(() =>
    createStyles({
        btnStyle: {
            color: "var(--white)",
            fontFamily: "noto-sans-cjk-jp,sans-serif",
            fontSize: "16px",
            minWidth: "160px",
            borderRadius: "21px",
            padding: "5px 20px",
            marginBottom: "30px",
        },
    })
);

function AddTimeline() {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    // Storeから値取得
    const { user, isTimelineCreateStatus, timeline, duplicateNameError } = useSelector(
        (state: AppState) => ({
            user: state.user.user,
            isTimelineCreateStatus: state.timeline.isTimelineCreateStatus,
            timeline: state.timeline.timeline,
            duplicateNameError: state.timeline.duplicateNameError,
        })
    );

    // Addボタンを押下の場合、
    const [openAddTimelinePage, setOpenTimelinePage] = useState(false);

    const [showError, setShowError] = useInitFlag();
    const handleAddButton = () => {
        setOpenTimelinePage(true);
    };
    const CloseAddTimelinePage = () => {
        setShowError(false);
        setTimelineName("");
        setOpenTimelinePage(false);
    };

    // タイムライン名入力処理
    const [timelineName, setTimelineName] = useInitText();
    // OKボタン活性・非活性用
    const [isOkBtnDisable, setIOkBtnDisable] = useState(true);
    const handleChangeTimelineName = (event: any) => {
        setTimelineName(event.target.value);
        if (isEmpty(event.target.value)) {
            setIOkBtnDisable(true);
        } else {
            setIOkBtnDisable(false);
        }
    };

    // OKボタン押下処理
    const [isTimelineCreate, setIsTimelineCreate] = useState(false);
    const handleClickAdd = () => {
        // タイムライン作成APIコール
        if (user) {
            dispatch(CreateTimeline(Number(user.id), timelineName));
        }
        // タイムライン名リセット
        setIsTimelineCreate(true);
    };

    useEffect(() => {
        if (isTimelineCreate && !isTimelineCreateStatus && timeline && duplicateNameError === "") {
            // モーダル閉じる
            CloseAddTimelinePage();
            setTimelineName("");
            //タイムライン編集画面へ遷移
            history.push("./editTimeline/" + timeline.timeline.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTimelineCreate, isTimelineCreateStatus]);

    useEffect(() => {
        if (
            isTimelineCreate &&
            !isTimelineCreateStatus &&
            !openAddTimelinePage &&
            duplicateNameError === ""
        ) {
            setIsTimelineCreate(false);
            setTimelineName("");
            // タイムライン作成後、モーダルを閉じてスタジオ編集画面へ遷移
            history.push("/videoTimeLine");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTimelineCreate, isTimelineCreateStatus, openAddTimelinePage]);

    useEffect(() => {
        if (isTimelineCreate && !isTimelineCreateStatus && duplicateNameError !== "") {
            setIsTimelineCreate(false);
            setShowError(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isTimelineCreate, isTimelineCreateStatus, openAddTimelinePage]);

    return (
        <div style={{ textAlign: "center", paddingTop: "30px" }}>
            <Button
                size="small"
                variant="outlined"
                className={classes.btnStyle}
                onClick={handleAddButton}
                style={{ backgroundColor: "var(--studio-btn-bg)" }}
            >
                新規プロジェクト
            </Button>
            <Modal open={openAddTimelinePage} onClose={CloseAddTimelinePage}>
                <div className={styles.addTimelinePage}>
                    <div className={styles.title}>
                        <PuiTypography>プロジェクト作成</PuiTypography>
                    </div>
                    <div className={styles.addProject}>
                        <FilledInput
                            value={timelineName}
                            id="ContentName"
                            placeholder="プロジェクト名を入力してください"
                            autoComplete="off"
                            disableUnderline={true}
                            className={styles.timelineInputBox}
                            onChange={handleChangeTimelineName}
                        />
                        <Button
                            disabled={isOkBtnDisable}
                            className={styles.addTimelineBtn}
                            onClick={handleClickAdd}
                            style={{
                                backgroundColor: "var(--studio-btn-bg)",
                                fontFamily: "noto-sans-cjk-jp",
                            }}
                        >
                            完了
                        </Button>
                    </div>
                </div>
            </Modal>

            <PuiMessage
                open={showError}
                type="warning"
                title={duplicateNameError}
                duration={5000}
                onClose={() => setShowError(false)}
            />
        </div>
    );
}

export default AddTimeline;
